import image1 from '../../assets/programs/research_blitz/image1.webp'

const research_blitz_data = {
    "title": "Research Blitz",
    "description": "A dozen distinguished Ph.D. scholars recently embarked on a remarkable endeavor: condensing their intricate research into brief 3-minute presentations, tailored for an audience unacquainted with their specialized fields. The outcome was nothing short of exhilarating—an intellectual convergence that harmonized the worlds of academia and the thirst for knowledge. We wish to express our deepest appreciation to all those who played a part in making this event an extraordinary success, as it effectively bridged the divide between complex ideas and the eager minds hungry to grasp them.",
    "content": [
        {
            "primaryHeading": "",
            "subContent": [
                {
                    "secondaryHeading": "",
                    "description": "Frequency : Once in 2 weeks.",
                    "images": [
                        {
                            "src": image1,
                            "desc": ""
                        }
                    ]
                }
            ]
        }
    ]
}

export default research_blitz_data;